export default __webpack_public_path__ + "static/media/MT.9533d127.svg";